module.exports = __webpack_public_path__ + "static/img/programmable-splitter_64.4c5975f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programmable-splitter_64.png
// module id = 5vgs
// module chunks = 0